import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { GlassIcon } from './SectionIcons';
export function Drinks() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const drinks = [{
    name: 'COCA-COLA',
    price: '4.000'
  }, {
    name: 'QUATRO',
    price: '4.000'
  }, {
    name: 'AGUA',
    price: '3.000'
  }, {
    name: 'AGUA CON GAS',
    price: '3.500'
  }];
  return <section className="w-full bg-bp-bg py-20 px-6 md:px-20 border-t border-bp-line" data-id="element-19">
      <div className="max-w-container mx-auto" data-id="element-20">
        <motion.div ref={ref} className="flex flex-col items-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6
      }} data-id="element-21">
          <GlassIcon className="mb-4" data-id="element-22" />
          <h2 className="font-display text-[32px] md:text-[48px] leading-none text-bp-text tracking-[0.1em] uppercase text-center" data-id="element-23">
            BEBIDAS
          </h2>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-6 max-w-4xl mx-auto" initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-24">
          {drinks.map((drink, index) => <div key={index} className="flex items-end w-full" data-id="element-25">
              <span className="font-body font-light text-bp-text text-lg whitespace-nowrap" data-id="element-26">
                {drink.name}
              </span>
              <div className="flex-grow border-b border-dotted border-bp-line mx-4 mb-1.5" data-id="element-27" />
              <span className="font-display text-bp-accent text-2xl tracking-wider whitespace-nowrap" data-id="element-28">
                ${drink.price}
              </span>
            </div>)}
        </motion.div>
      </div>
    </section>;
}